import * as React from 'react';
import { CompanySettingProvider, ICompanySettings } from '../../javascript/application/useCompanySettings';
import { FeatureFlagProvider, FeatureFlags } from '../../javascript/application/useFeatureFlags';
import { OnboardingSettings, OnboardingSettingsProvider } from '../../javascript/application/useOnboardingSettings';
import { LocaleContextProvider, TEnabledLocaleKeys } from './hooks/useLocaleContext';

export function GlobalProviderWrapper({
  companySettings,
  enabledLocaleKeys,
  featureFlags,
  onboardingSettings,
  children,
}: {
  companySettings: ICompanySettings;
  enabledLocaleKeys: TEnabledLocaleKeys;
  featureFlags: FeatureFlags;
  onboardingSettings: OnboardingSettings;
  children: React.ReactNode;
}) {
  return (
    <LocaleContextProvider enabledLocaleKeys={enabledLocaleKeys}>
      <FeatureFlagProvider featureFlags={featureFlags}>
        <CompanySettingProvider companySettings={companySettings}>
          <OnboardingSettingsProvider {...{ onboardingSettings }}>
            {/* Actual component being rendered */}
            {children}
          </OnboardingSettingsProvider>
        </CompanySettingProvider>
      </FeatureFlagProvider>
    </LocaleContextProvider>
  );
}
